var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hrm-home-container"
  }, [_c('div', {
    staticClass: "hrm-reports-container"
  }, [_c('div', {
    staticClass: "reportsLeftSideBar"
  }, [_vm._m(0), _c('div', {
    staticClass: "sideBarList-container"
  }, [_c('div', {
    staticClass: "sideBarList-inner"
  }, [_c('div', {
    staticClass: "sideBarList"
  }, [_vm._l(_vm.settings, function (setting) {
    return [_c('div', {
      key: setting.id,
      staticClass: "sideBarList-item",
      class: {
        'active': _vm.selectedTab.id == setting.id
      },
      on: {
        "click": function ($event) {
          _vm.selected.tab = setting.childrens ? setting.childrens[0].component : setting.component;
        }
      }
    }, [_c('div', {
      staticClass: "sideBarList-itemLeftSide"
    }, [_c('vb-icon', {
      staticClass: "sideBarList-icon",
      attrs: {
        "icon": setting.icon,
        "height": "17px",
        "width": "17px"
      }
    }), _c('div', {
      staticClass: "sideBarList-itemText"
    }, [_vm._v(_vm._s(setting.text))])], 1), setting.childrens ? _c('b-icon', {
      staticClass: "downIcon",
      attrs: {
        "icon": "chevron-down",
        "font-scale": "1.3"
      }
    }) : _vm._e()], 1), setting.childrens ? _c('div', {
      key: `children-${setting.id}`,
      staticClass: "sideBarSubItemsList",
      class: {
        'show h-auto': _vm.selectedTab.id == setting.id
      }
    }, _vm._l(setting.childrens, function (children) {
      return _c('div', {
        key: children.component,
        staticClass: "sideBarList-item",
        class: {
          'active': children.component == _vm.selected.tab
        },
        on: {
          "click": function ($event) {
            _vm.selected.tab = children.component;
          }
        }
      }, [_c('div', {
        staticClass: "sideBarList-itemLeftSide"
      }, [_c('div', {
        staticClass: "sideBarList-itemText"
      }, [_vm._v(_vm._s(children.text))])])]);
    }), 0) : _vm._e()];
  })], 2)])])]), _c('div', {
    staticClass: "reportsMainBody"
  }, [_vm._v(" " + _vm._s(_vm.selected.tab) + " "), _c(_vm.selected.tab, {
    tag: "component"
  })], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sideBarHeading-container"
  }, [_c('div', {
    staticClass: "sideBarHeading"
  }, [_vm._v(" Settings ")])]);

}]

export { render, staticRenderFns }